// ABOUTME: RTK Query endpoints for the invoicing configuration (root-api /invoicing):
// ABOUTME: default invoice lines and per-customer Asperion settings + custom invoice lines.

import { rootSlice } from "../createRootSlice";

export const invoicingConfigSlice = rootSlice.injectEndpoints({
    endpoints: (builder) => ({
        getInvoicingConfig: builder.query({
            query: () => ({
                url: `/invoicing/`,
                method: 'GET',
            }),
            providesTags: () => [{ type: 'InvoicingConfig' }],
        }),
        updateInvoicingDefaultLines: builder.mutation({
            query: (lines) => ({
                url: `/invoicing/defaultlines`,
                method: 'PUT',
                body: { lines },
            }),
            invalidatesTags: () => [{ type: 'InvoicingConfig' }],
        }),
        updateInvoicingCustomer: builder.mutation({
            query: ({ customerId, ...body }) => ({
                url: `/invoicing/customers/${customerId}`,
                method: 'PUT',
                body: body,
            }),
            invalidatesTags: () => [{ type: 'InvoicingConfig' }],
        }),
    }),
});

export const {
    useGetInvoicingConfigQuery,
    useUpdateInvoicingDefaultLinesMutation,
    useUpdateInvoicingCustomerMutation,
} = invoicingConfigSlice;
